<div class="sb-addons-select-wrapper">
    <div class="carousel-shadow left" *ngIf="isDesktop && showLeftShadow"></div>
    <div class="carousel-shadow right" *ngIf="isDesktop && showRightShadow"></div>
    <div class="sb-addons-select" #carouselContainer [formGroup]="formGroup" (wheel)="onMouseWheel($event)">
        <div class="addon-item" *ngFor="let addon of availableAddons; let i = index">
            <div class="addon-container" [ngClass]="{
              'sb-addon-select-single--checked': isSelected(addon.id)
              }" (keyup.Space)="toggle(addon.id)" tabindex="0">
                <div class="ribbon-container" *ngIf="addon.isNew">
                  <div class="novita-ribbon">{{'ENTITY.OFFER-EXTRAS.ADDONS.NOVITA-RIBBON'|translate}}</div>
                  <div class="ribbon-square"></div>
                </div>
                <div class="addon-header">
                  <div class="addon-icon">
                    <img [src]="adobeDamUrl + '/01-assets/ecommerce/icons/' + addon.id.toLowerCase() + '.svg'" [alt]="addon.title">
                  </div>
                  <div class="addon-title-subtitle">
                    <h3 class="addon-title">{{addon.title}}</h3>
                    <p class="addon-subtitle">{{addon.subtitle}}</p>
                  </div>
                  <wt-info-note [showCloseButton]="true" [invert]="false" width="500px" class="flex__info-note addon-info-note" text="{{addon.description}}"></wt-info-note>
                </div>

                <div class="addon-container__footer" *ngIf="shouldShowSpecialCard(addon)">
                    <div class="addon-container__footer-text">
                        <div class="centered-text">
                            <p class="normal">{{inferTitleBasedOnRepetitions(addon) | translate}}</p>
                            <p class="bold">
                                <span *ngIf="addon.price.value; else freePrice">{{addon.price.value | currency: addon?.price?.currency | inferCurrencyLabel}}</span>
                                <ng-template #freePrice><span>{{('ENTITY.OFFER-EXTRAS.ADDONS.GRATIS' | translate | uppercase )}}</span></ng-template>
                            </p>

                            <p class="subtext">
                                {{inferSubtitleBasedOnRepetitions(addon) | translate}}
                                <!--&nbsp;<span class="lt">{{this.hardCodedPreviousPrice | currency: addon?.price?.currency  | inferCurrencyLabel}}</span>-->
                                <span>{{addon?.price?.previous | currency: addon?.price?.currency | inferCurrencyLabel}}</span>
                            </p>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="activationFooter"></ng-container>
                    <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
                </div>


                <div class="addon-container__footer" *ngIf="!shouldShowSpecialCard(addon)">
                    <div class="addon-container__footer-price">
                        <div class="addon-container__footer-discount" *ngIf="addon?.price?.previous">
                            {{addon?.price?.previous | currency: addon?.price?.currency | inferCurrencyLabel}}
                        </div>
                        <div class="integer">
                            {{ ((addon.price.value ? addon.price.value : '0.00') | inferPriceSplit)[0] }}
                            <div class="decimal">
                                <span class="decimal-number" *ngIf="Number.isInteger(addon.price.value)">{{ ((addon.price.value ? addon.price.value : '0.00') | inferPriceSplit)[1] }}{{addon?.price?.currency | inferCurrencyLabel}}</span>
                                <span class="decimal-number" *ngIf="!Number.isInteger(addon.price.value)">,{{ ((addon.price.value ? addon.price.value : '0.00') | inferPriceSplit)[1] }}{{addon?.price?.currency | inferCurrencyLabel}}</span>
                                <span class="decimal-ric">{{addon?.price?.frequency | inferFrequencyLabel:null:'addon' | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="activationFooter"></ng-container>
                    <ng-container *ngTemplateOutlet="toggleButton"></ng-container>
                </div>

            </div>

            <ng-template #activationFooter>
                <!--        <div class="addon-container__footer-activation" *ngIf="addon.activationPrice">-->
                <!--          <span>{{'ENTITY.OFFER-EXTRAS.ADDONS.ACTIVATION' | translate}}</span>-->
                <!--          <span *ngIf="showActivationPricePrevious(addon) as activationPrevious">&nbsp;<span class="lt">{{activationPrevious | currency: showActivationPriceCurrency(addon) | inferCurrencyLabel}}</span></span>-->
                <!--          <span *ngIf="showActivationPriceValue(addon) as activationPrice;else freeActivation">&nbsp;{{activationPrice | currency: showActivationPriceCurrency(addon) | inferCurrencyLabel}}</span>-->
                <!--          <ng-template #freeActivation>-->
                <!--            {{ 'ENTITY.OFFER-EXTRAS.ADDONS.FREE_ACTIVATION' | translate }}-->
                <!--          </ng-template>-->
                <!--        </div>-->
            </ng-template>

            <ng-template #toggleButton>
                <input type="hidden" value="{{addon.id}}">
                <button class="wt-button wt-button--primary"
                        (click)="toggle(addon.id)"
                        [disabled]="isDisabled(addon.id)">
                    {{('ENTITY.OFFER-EXTRAS.ADDONS.' + (isSelected(addon.id) ? 'DELETE' : 'BUY') | translate)}}
                </button>
            </ng-template>

            <ng-template #price let-priceValue let-priceCurrency>
                {{priceValue | currency: priceCurrency | inferCurrencyLabel}}
            </ng-template>
        </div>
    </div>
    <ng-container *ngIf="isDesktop  && availableAddons && availableAddons.length >= 3">
        <div class="navigation-buttons">
            <button
                    class="nav-button left"
                    [ngClass]="{'disabled': leftButtonDisabled}"
                    (click)="scrollLeft()"
                    [disabled]="leftButtonDisabled"
                    [attr.aria-label]="'Scorri a sinistra'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button
                    class="nav-button right"
                    [ngClass]="{'disabled': rightButtonDisabled}"
                    (click)="scrollRight()"
                    [disabled]="rightButtonDisabled"
                    [attr.aria-label]="'Scorri a destra'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="isMobile && availableAddons && availableAddons.length > 1">
        <div class="addon-dots-container">
            <div *ngFor="let addon of availableAddons; let i = index"
                 class="addon-dot"
                 [class.active]="isDotActive(i)"
                 (click)="scrollCarousel(i)">
            </div>
        </div>
    </ng-container>
</div>
